export const oneOnOneRoomsContent = `Start a private video call with anyone — no account required for your guest.

1 on 1 Rooms are Free for all Batesky members

## How It Works
1. Enter your 1 on 1 Room
2. Share your room link with your bro
3. Your bro joins as Guest 

## Starting a Room
Tap the "Start 1 on 1 Room" button on the Home tab

## Inviting your bro
1 on 1 Rooms are secured by Jitsi

## Invite Codes
After a call ends, your guest will receive an invite code to join Batesky

If you need further help, send us a DM on the Bluesky app or contact us at [support@batesky.app](mailto:support@batesky.app).
`
